import _posthog from 'posthog-js'
import { PostHogProvider as _PostHogProvider, usePostHog as _usePostHog } from 'posthog-js/react'

export const usePostHog = _usePostHog
export const PostHogProvider = _PostHogProvider
export const posthog = _posthog
